/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { ProviderTableHead } from './TableHead';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import {
  dispatchQtrRange,
  dispatchErrorMsgClaim,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  dispatchProviderSelection,
  getProviderList,
  getReferenceData,
  dispatchProviderGridData,
  getProviderData,
  dispatchDisplayObjClaim,
  setPaginationIndex,
  getProviderIdsList,
  showNoDataMessage,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  PROVIDER_ID,
  PROVIDERMESSAGE,
} from '../../../../SharedModules/Errors/constantMessageData';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const DProviderClaim = (props) => {
  // use selector
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    selectedPlanType,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgClaim: getErrorMsg,
    quarterFrom: getQuarter,
    providerSelectionValue,
    providerIdValue,
    providerInfo,
    providerList,
    referenceData,
    providerGrid,
    referenceDataSelectedValue,
    isAllineligibleProviderSelected: isAllineligibleProviderSelectedValue,
    selectRowIndex: selectRowIndexValue,
    providerWithIdValue,
    menuNameValue,
  } = useSelector((state) => state?.sharedState?.DProviderClaimReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const dispatch = useDispatch();
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [referData, setReferData] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [startQtr, setStartQtr] = React.useState(getQuarter);
  const [provider, setProvider] = React.useState([]);
  const [providerId, setProviderId] = React.useState(providerIdValue);
  const [providerSelection, setProviderSelection] = React.useState(
    providerSelectionValue
  );
  const [scrollDownProvider, setScrollDownProvider] = React.useState(true);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [provSelected, setProvSelected] = React.useState('ALL');
  const [isAllineligibleProviderSelected, setIsAllineligibleProviderSelected] =
    React.useState(isAllineligibleProviderSelectedValue || true);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [menuName, setMenuName] = React.useState([]);
  const [providerWithId, setProviderWithId] = React.useState('ALL');
  // local variable
  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          startQtr: '',
          providerId: '',
          referenceDataSelected: referenceDataSelectedValue,
        }
  );
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }

    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgClaim(unique));
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (type === 'startQtr') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'startQtr',
              errorType: 'startQtrRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'startQtr',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          setStartQtr(autoFormateDate(value));
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          localErr.push({
            field: 'startQtr',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');
        if (type === 'startQtr') {
          localErr.push({
            field: 'startQtr',
            errorType: 'startQtrRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    if (type === 'providerId') {
      if (!value) {
        localErr =
          localErr && localErr?.filter((item) => item.field !== 'providerId');
        localErr.push({
          field: 'providerId',
          errorType: 'providerIdRequired',
          message: PROVIDER_ID,
        });
      } else {
        localErr =
          localErr && localErr?.filter((item) => item.field !== 'providerId');
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgClaim(unique));
  };
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/providerClaimListing', true);
    } else {
      tabHighLigther('/providerClaimListing', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // reference data api
  React.useEffect(() => {
    let data1 =
      referenceData?.PROVIDER_ID_TYPE_CD?.sort((a, b) =>
        a.codeValueID.codeValue > b.codeValueID.codeValue ? 1 : -1
      )?.map((item) => {
        return {
          ...item,
          codeValuetemp: item.codeValueID.codeValue,
          name: `${item.codeValueID.codeValue} | ${item.shortDescription}`,
          id: `${item.codeValueID.codeValue} | ${item.shortDescription}`,
        };
      }) || [];

    data1 = [...data1];
    setState({
      ...state,
      referenceDataSelected: referenceDataSelectedValue,
    });
    setReferData(data1);
  }, [referenceData, referenceDataSelectedValue]);
  React.useEffect(() => {
    if (!referenceData?.PROVIDER_ID_TYPE_CD?.length)
      dispatch(
        getReferenceData({
          codeDomainList: ['PROVIDER_ID_TYPE_CD'],
        })
      );
  }, []);

  const type = state?.referenceDataSelected;
  const parts = type?.split(' | ');
  const part1 = parts && parts[0];

  // provider list
  React.useEffect(() => {
    dispatch(
      getProviderList({
        providerIdTypeCd: part1,
      })
    );
  }, [part1, referenceDataSelectedValue]);
  React.useEffect(() => {
    setProvider(providerList?.providerIdAndName);
  }, [providerList]);
  // on selection changed
  const [numberOfSelectedRows, setNumberOfSelectedRows] = React.useState(0);
  const onSelectionChanged = (e, isAllChecked) => {
    if (isAllChecked) {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < provider.length; i++) {
        selectedMenuName.push(provider[i].providerName);
        temp.push({
          providerListId: provider[i].providerId,
          providerListName: provider[i].providerName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setProviderWithId(temp);
    } else {
      const selectedRows = e.api?.getSelectedRows();
      setNumberOfSelectedRows(e.api?.getSelectedRows().length);
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < selectedRows?.length; i++) {
        selectedMenuName.push(selectedRows[i]?.providerName);
        temp.push({
          providerListId: provider[i]?.providerId,
          providerListName: provider[i]?.providerName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setProviderWithId(temp);

      setSelectedRows(selectedRows);
      let localErr = getErrorMsg?.searchScreenErrors || [];
      localErr = localErr.filter((item) => item.field != 'noProvider');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgClaim(unique));
    }
  };

  // Search button on click functionality
  const onClickOnSearch = async (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let index = provider.findIndex(
      (obj) =>
        obj.providerId === selectedRows[0]?.providerId ||
        obj.providerId === selectedRowOnDoubleClick[0]?.providerId
    );
    index = index === -1 ? null : index;
    let localErr = getErrorMsg || [];
    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'startQtrRequired',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (!providerId && providerSelection == 'Eligible') {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'providerId');
      localErr.push({
        field: 'providerId',
        errorType: 'providerIdRequired',
        message: PROVIDER_ID,
      });
    }
    let sRows =
      (isAllineligibleProviderSelected ? provider : selectedRows) || [];
    /* istanbul ignore else */
    if (sRows.length == 0 && providerSelection != 'Eligible') {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'noProvider');
      localErr.push({
        field: 'noProvider',
        errorType: 'ProviderRequired',
        message: PROVIDERMESSAGE,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgClaim(unique));
    if (
      (unique.length === 0 && sRows.length === 1) ||
      (providerId != '' && providerSelection == 'Eligible')
    ) {
      setSearchClicked(true);

      dispatch(setPaginationIndex(1));
      dispatch(
        getProviderData({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          qtr: startQtr,
          providerId:
            providerSelection == 'Eligible'
              ? [providerId]
              : [sRows[0].providerId],
          providerIdTypeCd: part1,
          isInEligible: providerSelection == 'Eligible' ? 0 : 1,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange(startQtr));
      dispatch(
        dispatchProviderGridData(
          providerSelection == 'Eligible' ? providerId : sRows
        )
      );
      dispatch(
        dispatchProviderSelection({
          provSelected: provSelected,
          providerSelectionValue: providerSelection,
          providerIdValue: providerId,
          referenceDataSelectedValue: state?.referenceDataSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
          isAllineligibleProviderSelected,
        })
      );
      dispatch(
        dispatchDisplayObjClaim({
          rebateProgramName,
          provSelected: provSelected,
          providerSelectionValue: providerSelection,
          providerIdValue: providerId,
          referenceDataSelectedValue: state?.referenceDataSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
          isAllineligibleProviderSelected,
          quarterFrom: startQtr,
          providerGridData:
            providerSelection == 'Eligible' ? providerId : sRows,
        })
      );
    }
    if (
      unique.length === 0 &&
      sRows.length > 1 &&
      providerSelection == 'Ineligible'
    ) {
      let response = await dispatch(
        getProviderIdsList({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          qtr: startQtr,
          providerId: sRows.map((o) => o.providerId),
          providerIdTypeCd: part1,
          isInEligible: 1,
        })
      );
      if (response?.length) {
        sRows = sRows.filter((o) => response.indexOf(o.providerId) !== -1);
      } else {
        // setSearchClicked(true);
        dispatch(showNoDataMessage());
        return;
      }
      dispatch(setPaginationIndex(1));
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange(startQtr));
      dispatch(
        dispatchProviderGridData(
          providerSelection == 'Eligible' ? providerId : sRows
        )
      );
      dispatch(
        dispatchProviderSelection({
          provSelected: provSelected,
          providerSelectionValue: providerSelection,
          providerIdValue: providerId,
          referenceDataSelectedValue: state?.referenceDataSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
          isAllineligibleProviderSelected,
        })
      );
      dispatch(
        dispatchDisplayObjClaim({
          rebateProgramName,
          provSelected: provSelected,
          providerSelectionValue: providerSelection,
          providerIdValue: providerId,
          referenceDataSelectedValue: state?.referenceDataSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
          isAllineligibleProviderSelected,
          quarterFrom: startQtr,
          providerGridData:
            providerSelection == 'Eligible' ? providerId : sRows,
        })
      );
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/displayProviderClaimListing',
        value: 'Display Provider Claim Listing',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props &&
        props.history &&
        props.history.push({
          pathname: '/displayProviderClaimListing',
        });
      dispatch(clearReduxForFilterAndSort('/displayProviderClaimListing'));
    }
  };

  if (
    isSearchClicked &&
    providerInfo?.providerclaimListingDetails?.detailPageGridList.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayProviderClaimListing',
      value: 'Display Provider Claim Listing',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props &&
      props.history &&
      props.history.push({
        pathname: '/displayProviderClaimListing',
      });
    dispatch(clearReduxForFilterAndSort('/displayProviderClaimListing'));
  }
  // setting Quarter From
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgClaim(unique));
  };
  // setting provider ID
  const handleProviderChange = (event) => {
    setProviderId(event.target.value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'providerId ');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgClaim(unique));
  };

  // For No Data validation for Auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);
              
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgClaim([]));
  }, [state.planTypeCd, state.rebateProgramCd, startQtr, providerSelection, state.referenceDataSelected, isAllineligibleProviderSelected, fullScreenView]);

  // const cellClickedListener = (e) => {
  //   setSelectedRows([e?.data]);
  //   onClickOnSearch(null, true, [e?.data]);
  // };
  const [gridApi, setGridApi] = React.useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || ProviderTableHead === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows?.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
    }
  }, [gridApi, ProviderTableHead]);
  return (
    <div
      className="tabs-container tBillPanel custom-check"
      data-testid="program-and-eligibility"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Provider Claim Listing"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0
              ? [...new Set(_.map(getErrorMsg, (l) => l.message))]
              : []
          }
        />
      ) : null}
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="radio-button-for-dpcl"
                id="radio-button-for-rcdd_id"
                labelName="Plan Type"
                required
                optionList={radioList || []}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Rebate Program<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      data-testid="rebate-program-dpcl"
                      id="rebate_program"
                      label="Rebate Program"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      data-testid="check_by_invoice_quater_dpcl"
                      id="check_by_invoice_quater"
                      label="dprovider"
                      required
                      fullWidth
                      value={startQtr}
                      onChange={handlefromChange}
                      placeholder=""
                      inputProps={{
                        maxLength: 6,
                        id: 'check_by_invoice_quater',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="startQtr"
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'startQtr' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('startQtr', e.target.value)
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'startQtr' ? l.message : null
                            )
                          : null
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'startQtr' ? l.message : null
                            )
                          : null
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-4 ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Provider Selection <span className="mandatory"> *</span>
                </legend>
                <div className="mui-custom-form input-md field-xl">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name="Provider Selection"
                        value={providerSelection}
                      >
                        <FormControlLabel
                          data-testid="ineligible-radio-button-dpcl"
                          value="Ineligible"
                          control={<Radio />}
                          label="Select Ineligible"
                          name="Ineligible"
                          onChange={(e) => setProviderSelection(e.target.value)}
                        />
                        <FormControlLabel
                          data-testid="eligible-radio-button-dpcl"
                          value="Eligible"
                          control={<Radio />}
                          label="Enter Provider ID"
                          onChange={(e) => setProviderSelection(e.target.value)}
                          name="Eligible"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Provider ID Type<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name=" Provider ID Type"
                      data-testid="provider-ID-type-dpcl"
                      id="providerIDType"
                      label=" Provider ID Type"
                      fullWidth
                      select
                      required
                      inputProps={{
                        maxLength: 11,
                        id: 'providerIDType',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setState({
                          ...state,
                          referenceDataSelected: e.target.value,
                        });
                      }}
                      value={
                        state && state.referenceDataSelected
                          ? state.referenceDataSelected
                          : ''
                      }
                    >
                      {referData && referData.length && referData.length > 0
                        ? referData.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            {providerSelection == 'Ineligible' && (
              <div className="col-4" style={{ marginTop: '50px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      data-testid="ineligible-providers-for-id-dpcl"
                      color="primary"
                      name="IneligibleProvidersForID"
                      checked={isAllineligibleProviderSelected}
                      onChange={(e) => {
                        setIsAllineligibleProviderSelected(
                          !isAllineligibleProviderSelected
                        );
                        if (!isAllineligibleProviderSelected) {
                          setProvSelected('ALL');
                        } else {
                          setProvSelected([]);
                        }
                        // setScrollDownProvider(!setScrollDownProvider);
                        // if (!isAllineligibleProviderSelected) {
                        //   setProvSelected('ALL');
                        // } else {
                        //   setProvSelected([]);
                        // }
                        // const elem = document.getElementById('abc11');
                        // if (elem && scrollDownProvider) {
                        //   setTimeout(() => {
                        //     elem.scrollIntoView();
                        //   }, 1000);
                        // }
                        let localErr = getErrorMsg || [];
                        localErr = localErr.filter(
                          (item) => item.field !== 'noProvider'
                        );
                        const unique = [...new Set(localErr)];
                        dispatch(dispatchErrorMsgClaim(unique));
                      }}
                    />
                  }
                  label="All Ineligible Providers for this ID Type"
                />
              </div>
            )}
            {providerSelection == 'Eligible' && (
              <div className="col-4 frr-two-col-radio">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Provider ID<span className="mandatory"> *</span>
                  </legend>
                  <div className="form-wrapper p-3">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        data-testid="provider-id-dpcl"
                        id="providerId"
                        label=" ProviderId"
                        required
                        fullWidth
                        value={providerId}
                        onChange={handleProviderChange}
                        onBlur={(e) =>
                          handleOnblurEvent('providerId', e.target?.value)
                        }
                        placeholder=""
                        inputProps={{ maxLength: 12 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="providerId"
                        className={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field == 'providerId'
                                  ? 'mandate-fields'
                                  : null
                              )
                            : null
                        }
                        helperText={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'providerId' ? l.message : null
                              )
                            : null
                        }
                        error={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field == 'providerId' ? l.message : null
                              )
                            : null
                        }
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            )}
          </div>

          <div className="col-12 btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Process
              </Button>
            </div>
          </div>
        </>
      )}
      <br />
      <br />
      {providerSelection == 'Ineligible' &&
        !isAllineligibleProviderSelected && (
          <div
            className="panel-body FRR-custom-table tbl-Provfacturer-inner"
            id="abc11"
          >
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              helpMessage
              gridCall={onGridReady}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={ProviderTableHead}
              rowData={provider}
              // cellClickedListener={cellClickedListener}
              selectRowIndex={selectRowIndexValue}
              rowSelection="single"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Provider List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
    </div>
  );
};

export default DProviderClaim;
